<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'market'
    }
</script>

<style lang="scss" scoped>

</style>